import "./Input.styles.scss";

export const MyButton = ({ ...props }) => {
  return (
    <div>
      <button
        type='submit'
        onClick={props.onClick}
        disabled={props.disabled}
        className={`${props.btnClass} || button`}
      >
        {props.text}
      </button>
    </div>
  );
};
